import { FC } from 'react';
import { SvgIconProps } from '@mui/material';
import { InBoxIn } from './svgs';
import { StyledSvgIcons } from './styled';

export const InBoxInOutline: FC<SvgIconProps> = (props) => {
  return <StyledSvgIcons component={InBoxIn} viewBox="0 0 24 24" {...props} />;
};
